module.exports = __webpack_public_path__ + "static/eingang-f6dc5b310dbf224e8899713585e7ff56.jpg";